import styled from 'styled-components';
import EditButton from '../../../EditButton';

const StyledReloadButton = styled(EditButton)`
  svg {
    height: 16px;
    width: 16px;

    path {
      fill: ${props => props.theme.colors.neutral_6};
    }
  }
`;

export {
  StyledReloadButton
}
